import React, { forwardRef, InputHTMLAttributes } from "react";
import { InputContainer } from "./styles";
import { Caption4, Wrap } from "components/Common";
import Spacing from "components/Common/Spacing";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: boolean;
  errorMasaage?: string;
  // 에러 메시지 노출 영역을 포함할지 여부
  defaultFillErrorBoundary?: boolean;
};
export const Input =
  // eslint-disable-next-line react/display-name
  forwardRef<HTMLInputElement, InputProps>(
    (
      { label, errorMasaage, defaultFillErrorBoundary = true, ...props },
      ref
    ) => {
      return (
        <Wrap direction="column" gap="5px" align="start">
          <InputContainer
            width={props.width}
            disabled={props.disabled}
            error={props.error}
          >
            <input ref={ref} {...props} />
            {label && <Caption4 color="Gray40">{label}</Caption4>}
          </InputContainer>
          {errorMasaage ? (
            <Wrap gap="6px">
              <Caption4 color="Red">{errorMasaage}</Caption4>
            </Wrap>
          ) : (
            defaultFillErrorBoundary && <Spacing height="19.5px" />
          )}
        </Wrap>
      );
    }
  );
